import { changesPrefix } from "./constants";

export const isModelChanged = (model: any) => {
  if (!model) {
    return undefined;
  }

  const changes = model[changesPrefix];
  return changes ? !!Object.keys(changes)?.length : undefined;
};
